import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CbjInViewDirective } from './directives/cbj-in-view.directive';
import { CbjParallaxDirective } from './directives/cbj-parallax.directive';
import { CbjScrollbarDirective } from './directives/scrollbar.directive';
import { CbjAnimInViewComponent } from './anim-in-view/cbj-anim-in-view.component';
export class CbjScrollModule {static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CommonModule
  ],
  declarations: [
    CbjInViewDirective,
    CbjAnimInViewComponent,
    CbjParallaxDirective,
    CbjScrollbarDirective,
  ],
  exports: [
    CbjInViewDirective,
    CbjAnimInViewComponent,
    CbjParallaxDirective,
    CbjScrollbarDirective,
  ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function CbjScrollModule_tsickle_Closure_declarations() {
/** @type {?} */
CbjScrollModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CbjScrollModule.ctorParameters;
}



interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
